/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Cite API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RightSideDisplay = {
    ScoreSummary: 'ScoreSummary',
    HtmlBlock: 'HtmlBlock',
    EmbeddedUrl: 'EmbeddedUrl',
    Scoresheet: 'Scoresheet',
    None: 'None'
} as const;
export type RightSideDisplay = typeof RightSideDisplay[keyof typeof RightSideDisplay];

